import { Injectable } from '@angular/core';
import { HttpClient,HttpResponse,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OmekaClassicService {

  /*
  http://oralitatdegasconha.net/culturaviva/api/resources?pretty_print
  */

  url:string = "http://oralitatdegasconha.net/culturaviva/"
  tagsUrl:string = "api/tags"
  itemsUrl:string = "api/items"

  constructor(private http: HttpClient) { }

  getTags(url:string):Observable<HttpResponse<any[]>>  {
    return this.http.get<any>(url+this.tagsUrl, {
      observe: 'response',
    });
  }


  // TODO: Upgrade omeka to +2.5 ... 
  getItems(feed):Observable<HttpResponse<any[]>> {
    return this.http.get<any>(feed.url+this.itemsUrl, {
      //+"?per_page="+feed.per_page+"&page="+feed.page
      params: {
        per_page:feed.per_page,
        page:feed.page,
        // search:feed.search, // v+2.5
      },
      observe: 'response',
    })
  }

}
